module.exports = __webpack_public_path__ + "media/app/components/MainNav/KamereoV2.351cdf84.svg";